// Order matters: bootstrap must run before any component imports, because the
// legacy components reference window.axios / window._ / window.moment at parse
// time in some places.
import './plugins/bootstrap'
import './plugins/vue-globals'
import './styles/swal-compact.css'
import './styles/ios-fixes.css'
import './styles/bill-light.css'
import './styles/action-buttons.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { registerBackButton } from './plugins/capacitor-back-button'
import { registerTapFeedback } from './plugins/tap-feedback'

Vue.config.productionTip = false

const vm = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// Expose root so the back-button plugin can fire notifications
window.__vueRoot__ = vm

// Wire Android hardware back button → Vue Router
registerBackButton(router)

// Click sound + light haptic on every button/interactive press
registerTapFeedback()
